<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>栅栏信息管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud :fields="fields" :select="select" :limits="limits" apiU="Fence"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						rule: [
							{ required: true, message: '请输入栅栏名称', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'fenceType',
						label: '类型',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							data: [
								{
									label: '未认领栅栏',
									value: '1'
								},
								{
									label: '已认领栅栏',
									value: '2'
								}
							],
							prop: {
								label: 'label',
								value: 'value'
							}
						},
						rule: [
							{ required: true, message: '请选择栅栏类型', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'videoId',
						label: '摄像头编号',
						type: 'string',
						rule: [
							{ required: true, message: '请输入摄像头编号', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'image',
						label: '图片',
						type: 'image',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'images',
						label: '更多图片',
						type: 'images',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'remarks',
						label: '备注',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [
					{
						name: 'fenceType',
						label: "是否认领",
						selection: {
							data: [
								{
									label: '未认领栅栏',
									value: '1'
								},
								{
									label: '已认领栅栏',
									value: '2'
								}
							],
							prop: {
								label: 'label',
								value: 'value'
							}
						}
					}
				],
				limits: {
					add: true,
					delete: true,
					edit: true,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
